"use client";

import { useRef, useMemo } from "react";
import LeagueFilterV5 from "@/components/LeagueFilterV5";
import BookmakerSelectV5 from "@/components/BookmakerSelectV5";
import { BANKER, BANKER_EXTENDS } from "@/contants";
import styles from "./index.module.css";

const getFilterButtonClass = (active) =>
  `${styles.filterButton} ${active ? styles.filterButtonActive : styles.filterButtonInactive}`;

export default function KBVFilterV5({
  isHotOnly = false,
  onHotChange,
  selectedLeagueIds = [],
  onLeagueChange,
  bookmarkerExtend,
  onBookmakerExtendChange,
  bookmarker,
  onBookmakerChange,
  oddsPeriod,
  onOddsPeriodChange,
}) {
  const filterRowRef = useRef(null);

  const bookmakerOptions = useMemo(
    () => [
      { value: "-1", label: "Tất cả" },
      ...BANKER.map((item) => ({ value: item.value, label: item.name })),
    ],
    [],
  );

  const bookmakerExtendOptions = useMemo(
    () =>
      BANKER_EXTENDS.map((item) => ({
        value: item.value,
        label: `Tỷ lệ ${item.shortName}`,
      })),
    [],
  );

  const oddsPeriodOptions = useMemo(
    () => [
      { value: "full", label: "Cả trận" },
      { value: "half1", label: "Kèo hiệp 1" },
    ],
    [],
  );

  return (
    <div className={`kbv-filter-v5 ${styles.scope}`}>
      <div
        ref={filterRowRef}
        className={styles.filterRow}
      >
      <button
        type="button"
        onClick={() => onHotChange?.(!isHotOnly)}
        className={`${styles.hotButton} ${getFilterButtonClass(isHotOnly)}`}
      >
        Trận Hot
      </button>

      <div className={styles.leagueWrap}>
        <LeagueFilterV5
          anchorRef={filterRowRef}
          selectedIds={selectedLeagueIds}
          onChange={onLeagueChange}
          scopeClassName="kbv-filter-v5-portal"
        />
      </div>

      <BookmakerSelectV5
        value={bookmarkerExtend}
        onChange={onBookmakerExtendChange}
        options={bookmakerExtendOptions}
        placeholder="Tỷ lệ HONGKONG"
        className={`${styles.selectBase} ${styles.selectExtend}`}
        triggerClassName={styles.selectTrigger}
        scopeClassName="kbv-filter-v5-portal"
        variant="outline"
      />
      <BookmakerSelectV5
        value={bookmarker}
        onChange={onBookmakerChange}
        options={bookmakerOptions}
        placeholder="Tất cả"
        className={`${styles.selectBase} ${styles.selectBookmaker}`}
        triggerClassName={styles.selectTrigger}
        scopeClassName="kbv-filter-v5-portal"
      />
      <BookmakerSelectV5
        value={oddsPeriod}
        onChange={onOddsPeriodChange}
        options={oddsPeriodOptions}
        placeholder="Cả trận"
        className={`${styles.selectOddsPeriod}`}
        triggerClassName={styles.selectTrigger}
        scopeClassName="kbv-filter-v5-portal"
        variant="outline"
      />
      </div>
    </div>
  );
}
